export interface MyStoriesModel {
  title: string;
  category: string;
  sendDate: string;
  situation: string;
}

interface Autorizacoes {
  // TODO se vem do backend tem que ter o sufixo "Dto", com o nome em ingles, não?
  idPessoaAutorizacao: number;
  stAutorizacao: string;
}

export interface StoriesListDto {
  id: number;
  titulo: string;
  idCategoria: number;
  categoria: string;
  dataEnvio: string;
  situacao: string;
  autorizacoes?: Autorizacoes[];
}

export interface StoryStatsModel {
  myStories: number;
  othersStories: number;
}

export interface StoryStatsDto {
  minhasHistorias: number;
  outrasHistorias: number;
}

export const StoriesType = {
  myStories: 'HISTORIA_PROPRIA',
  othersStories: 'OUTRA_HISTORIA',
} as const;

export type StoryType = (typeof StoriesType)[keyof typeof StoriesType];

export interface StoryFilter {
  idEspacoOcupacionalCategoria?: number;
  ciclo: number;
  tipoHistoria: StoryType;
  idCategoria?: string;
  situacao?: string;
}

export interface SavedInitialMyStoryModel {
  id: number;
}

export function storyStatsDtoToModel(dto: StoryStatsDto): StoryStatsModel {
  return {
    myStories: dto.minhasHistorias,
    othersStories: dto.outrasHistorias,
  };
}

export function storyFilterToApply({
  idCategoria,
  idEspacoOcupacionalCategoria,
  ciclo,
  situacao,
  tipoHistoria,
}: StoryFilter): StoryFilter {
  return {
    ciclo,
    tipoHistoria,
    ...(idCategoria && { idCategoria }),
    ...(idEspacoOcupacionalCategoria && { idEspacoOcupacionalCategoria }),
    ...(situacao && { situacao }),
  };
}
